<template>
  <el-dialog :title="$t('activitiesManage.add.title')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item :label="$t('activitiesManage.add.title')" prop="title">
        <el-input v-model="form.title" :placeholder="$t('activitiesManage.add.titlePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.typeCd')" prop="typeCd">
        <el-select v-model="form.typeCd" :placeholder="$t('activitiesManage.add.typeCdPlaceholder')" style="width:100%">
          <el-option v-for="item in typeCds" :key="item.typeCd" :label="item.typeName" :value="item.typeCd" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.isMoreCommunity')">
        <el-select v-model="form.isMoreCommunity" :placeholder="$t('activitiesManage.add.isMoreCommunityPlaceholder')"
          style="width:100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.headerImg')" prop="headerImg">
        <upload-image-url ref="uploadImage" :limit="1" @notifyUploadCoverImage="handleImageChange" />

      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.startTime')" prop="startTime">
        <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"          :placeholder="$t('activitiesManage.add.startTimePlaceholder')" style="width:100%"
           />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.endTime')" prop="endTime">
        <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"          :placeholder="$t('activitiesManage.add.endTimePlaceholder')" style="width:100%"
           />
      </el-form-item>
      <!-- 新增的三个字段 -->
      <el-form-item :label="$t('activitiesManage.add.signUpStartTime')" prop="signUpStartTime">
        <el-date-picker 
          v-model="form.signUpStartTime" 
          type="datetime" 
          value-format="yyyy-MM-dd HH:mm:ss" 
          :placeholder="$t('activitiesManage.add.signUpStartTimePlaceholder')" 
          style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.signUpEndTime')" prop="signUpEndTime">
        <el-date-picker 
          v-model="form.signUpEndTime" 
          type="datetime" 
          value-format="yyyy-MM-dd HH:mm:ss" 
          :placeholder="$t('activitiesManage.add.signUpEndTimePlaceholder')" 
          style="width:100%" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.location')" prop="location">
        <el-input 
          v-model="form.location" 
          :placeholder="$t('activitiesManage.add.locationPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.isCharge')">
        <el-select v-model="form.isCharge" :placeholder="$t('activitiesManage.add.isChargePlaceholder')"
          style="width:100%" @change="handleIsChargeChange">
          <el-option :label="$t('common.no')" value="N" />
          <el-option :label="$t('common.yes')" value="Y" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.isCharge === 'Y'" :label="$t('activitiesManage.add.feeAmount')" prop="feeAmount">
        <el-input v-model="form.feeAmount" type="number" min="0" step="0.01"
          :placeholder="$t('activitiesManage.add.feeAmountPlaceholder')">
          <template slot="append">{{ $t('activitiesManage.add.feeAmountUnit') }}</template>
        </el-input>
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.hasSignUpLimit')">
        <el-select v-model="form.hasSignUpLimit" :placeholder="$t('activitiesManage.add.hasSignUpLimitPlaceholder')"
          style="width:100%" @change="handleHasSignUpLimitChange">
          <el-option :label="$t('common.no')" value="N" />
          <el-option :label="$t('common.yes')" value="Y" />
        </el-select>
      </el-form-item>
      <el-form-item v-if="form.hasSignUpLimit === 'Y'" :label="$t('activitiesManage.add.signUpLimit')" prop="signUpLimit">
        <el-input v-model="form.signUpLimit" type="number" min="1"
          :placeholder="$t('activitiesManage.add.signUpLimitPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('activitiesManage.add.context')" prop="context">
        <rich-text-editor ref="richTextEditor" v-model="form.context" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleSubmit">{{ $t('common.submit') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { saveActivities, listActivitiesType } from '@/api/oa/activitiesManageApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'
import RichTextEditor from "@/components/editor/RichTextEditor";

export default {
  name: 'AddActivitiesView',
  components: {
    UploadImageUrl,
    RichTextEditor
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        title: '',
        typeCd: '',
        headerImg: '',
        context: '',
        startTime: '',
        endTime: '',
        signUpStartTime: '',
        signUpEndTime: '',
        location: '',
        isMoreCommunity: '',
        isCharge: 'N',
        feeAmount: '',
        hasSignUpLimit: 'N',
        signUpLimit: '',
        communityId: ''
      },
      typeCds: [],
      rules: {
        title: [
          { required: true, message: this.$t('activitiesManage.validate.titleRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('activitiesManage.validate.titleMaxLength'), trigger: 'blur' }
        ],
        typeCd: [
          { required: true, message: this.$t('activitiesManage.validate.typeCdRequired'), trigger: 'change' }
        ],
        headerImg: [
          { required: true, message: this.$t('activitiesManage.validate.headerImgRequired'), trigger: 'change' }
        ],
        context: [
          { required: true, message: this.$t('activitiesManage.validate.contextRequired'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('activitiesManage.validate.startTimeRequired'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('activitiesManage.validate.endTimeRequired'), trigger: 'change' }
        ],
        signUpStartTime: [
          { required: true, message: this.$t('activitiesManage.validate.signUpStartTimeRequired'), trigger: 'change' }
        ],
        signUpEndTime: [
          { required: true, message: this.$t('activitiesManage.validate.signUpEndTimeRequired'), trigger: 'change' }
        ],
        location: [
          { required: true, message: this.$t('activitiesManage.validate.locationRequired'), trigger: 'blur' }
        ],
        feeAmount: [
          { required: true, message: this.$t('activitiesManage.validate.feeAmountRequired'), trigger: 'blur' },
          { pattern: /^(0\.\d{1,2}|[1-9]\d*(\.\d{1,2})?)$/, message: this.$t('activitiesManage.validate.feeAmountInvalid'), trigger: 'blur' }
        ],
        signUpLimit: [
          { required: true, message: this.$t('activitiesManage.validate.signUpLimitRequired'), trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: this.$t('activitiesManage.validate.signUpLimitInvalid'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
        this.$refs.uploadImage && this.$refs.uploadImage.clearImages()
        this.loadActivitiesType()
      })
    },
    async loadActivitiesType() {
      try {
        const params = {
          page: 1,
          row: 50,
          communityId: getCommunityId()
        }
        const { data } = await listActivitiesType(params)
        this.typeCds = data
      } catch (error) {
        console.error('获取活动类型失败:', error)
      }
    },
    handleImageChange(images) {
      this.form.headerImg = images.length > 0 ? images[0] : ''
    },
    handleIsChargeChange() {
      if (this.form.isCharge !== 'Y') {
        this.form.feeAmount = ''
        this.$refs.form && this.$refs.form.clearValidate(['feeAmount'])
      }
    },
    handleHasSignUpLimitChange() {
      if (this.form.hasSignUpLimit !== 'Y') {
        this.form.signUpLimit = ''
        this.$refs.form && this.$refs.form.clearValidate(['signUpLimit'])
      }
    },
    async handleSubmit() {
      // 动态清除非必填字段的校验
      if (this.form.isCharge !== 'Y') {
        this.form.feeAmount = ''
      }
      if (this.form.hasSignUpLimit !== 'Y') {
        this.form.signUpLimit = ''
      }
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            this.form.communityId = getCommunityId()
            await saveActivities(this.form)
            this.$message.success(this.$t('common.operationSuccess'))
            this.dialogVisible = false
            this.$emit('success')
          } catch (error) {
            console.error('保存活动失败:', error)
          }
        }
      })
    },
    handleClose() {
      if (this.$refs.richTextEditor) {
        this.$refs.richTextEditor.clear();
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>